import { Injectable } from "@angular/core";
import { Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { Observable, of, EMPTY } from "rxjs";
import { mergeMap, take } from "rxjs/operators";

import { DataService } from "../services/data/data.service";
import { ProfileModel } from "../models/profile.model";

@Injectable({
  providedIn: "root"
})
export class MyConsumersResolverService implements Resolve<ProfileModel[]> {
  constructor(private dataService: DataService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ProfileModel[]> | Observable<never> {
    const id = route.paramMap.get("profileId");
    return this.dataService.getMyConsumers(id).pipe(
      take(1),
      mergeMap(item => {
        if (item) {
          return of(item);
        } else {
          // id not found
          return EMPTY;
        }
      })
    );
  }
}
